module.exports = __webpack_public_path__ + "img/warning-icon.7d3ad524.svg";